import React from 'react';

import FormLogin from 'my-components/admin/auth/FormLogin';

const LoginView = () => {
	return (<FormLogin />);
}

export default LoginView;